import React from 'react';
import { X, Check, Square } from 'lucide-react';
import EditableText from './EditableText';

const MAX_TASK_LENGTH = 60;

const TaskItem = ({ item, onToggle, onDelete, onEdit, color }) => {
  return (
    <div className="flex items-start space-x-2 mb-4">
      <button onClick={() => onToggle(item.id)} className="flex-shrink-0 focus:outline-none mt-1">
        {item.checked ? <Check size={18} /> : <Square size={18} />}
      </button>
      <div className="flex-grow">
        <EditableText
          text={item.text}
          maxLength={MAX_TASK_LENGTH}
          onSave={(newText) => onEdit(item.id, newText)}
          onCancel={() => { }}
          isTextArea={true}
          label="Subtask"
          isCompleted={item.checked}
          color={color}
        />
      </div>
      <button onClick={() => onDelete(item.id)} className="flex-shrink-0 text-gray-500 hover:text-red-500 focus:outline-none mt-1">
        <X size={16} />
      </button>
    </div>
  );
};

export default TaskItem;